import React, { useEffect, useState } from "react";
import { Loader, Table } from "semantic-ui-react";
import { useCrashPoints, useCrashPointsConfigTable, useCrashPointsFilterList } from "./CrashPointsHooks";
import Filter from "../../Filter";
import Label from "../../Label";
import Paginator from "../../Paginator";
import DateRangePicker from "components/MainPage/Filter/DateRangePicker";
import "./CrashPointsTable.css";

const CrashPointsTable = ({ pushNotify, logout, intl, initDate, initFilter }) => {
  const [range, setRange] = useState(initDate);
  
  const [filter, setFilter] = useState(initFilter);
  const [options, setOptions] = useState({});
  const [isFilterActive, setIsFilterActive] = useState(false);

  const [crashPointsList, page, pageCount, loadCrashPointsFromPage, loading] =
    useCrashPoints({ range, pushNotify, logout, filter, setIsFilterActive });
  const tableConfig = useCrashPointsConfigTable();

  const filterList = useCrashPointsFilterList({options, intl})

  const getTranslate = (fieldName, value) => {
    switch (fieldName) {
      case "reason":
        return intl.formatMessage({ id: `reason.${value}` });
      case "currentPoint":
        return value ? intl.formatMessage({ id: `controlPoint.${value}` }) : null;
      case "status":
        return intl.formatMessage({ id: `crash.status.${value}` });
      default:
        return value;
    }
  };

  const setFilterHandler = (e) => {
    if (e.departureId) {
      const newFilter = {};
      for (const key in e) {
        if (key !== "departureId") newFilter[key] = e[key];
      }
      setFilter({ ...newFilter });
    } else {
      setFilter(e);
    }
  };

  return (
    <div className="crash-points-table">
        <div className="topPanel">
            <div>
              <DateRangePicker value={range} onChange={setRange} />
            </div>
            <Filter
                filter={filter}
                disabled={loading}
                setFilter={(e)=>setFilterHandler(e)}
                filterList={filterList}
                isFilterActive={isFilterActive}
                className="modalMaxWidth"
            />
        </div>
        <Table celled striped>
          <Table.Header>
            <Table.Row>
              {tableConfig.map((conf) => (
                <Table.HeaderCell key={conf.id}>
                  {intl.formatMessage({ id: conf.headerTranslatePath })}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          </Table.Header>

          {loading ? (
            <Table.Body>
              <Table.Row>
                <Table.Cell colSpan={tableConfig.length}>
                  <Loader className={"page-loader"} active inline="centered" />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          ) : crashPointsList.length === 0 ? (
            <Table.Body>
              <Table.Row>
                <Table.Cell colSpan={tableConfig.length}>
                  <Label text={intl.formatMessage({ id: 'title.recordNotFound' })} />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          ) : (
            <Table.Body>
              {crashPointsList.map((crash) => (
                <Table.Row key={crash.id}>
                  {tableConfig.map((conf) => (
                    <Table.Cell key={conf.id}>
                      {conf.needTranslate
                        ? getTranslate(conf.fieldName, crash[conf.fieldName])
                        : crash[conf.fieldName]}
                    </Table.Cell>
                  ))}
                </Table.Row>
              ))}
            </Table.Body>
          )}
        </Table>

        <Paginator
          pageCount={pageCount}
          page={page}
          setPage={loadCrashPointsFromPage}
          disabled={loading}
        />
    </div>
  );
};

export default CrashPointsTable;
